export default __webpack_public_path__ + "static/media/form_design.5c3c3d1f.png";